import { useRef } from "react";
import { useEffect } from "react";
import "../../../assets/style/featuresStyle/button.scss";
import { useState } from "react";
import { IconAddIMG, IconEdit } from "../../../assets/icon";
const UploadImage = ({
  setImage,
  width,
  height,
  url,
  className,
  style,
  accept,
  setFile,
}) => {
  const [isPreview, setIsPreview] = useState(url ? true : false);
  const [previewIMG, setPreviewIMG] = useState();
  const handlePreviewIMG = (e) => {
    const file = e.target.files[0];
    file.preview = URL.createObjectURL(file);
    setImage(file);
    setPreviewIMG(file);
    setFile(file);
  };
  const inputRef = useRef();
  useEffect(() => {
    if (previewIMG) {
      setIsPreview(false);
    }
  }, [previewIMG]);
  useEffect(() => {
    if (previewIMG) {
      setIsPreview(false);
    }
  }, [previewIMG]);
  useEffect(() => {
    return () => {
      previewIMG && URL.revokeObjectURL(previewIMG.preview);
    };
  }, [previewIMG]);
  const handleChooseImage = (e) => {
    inputRef.current.click();
  };
  const styleBtn = {
    width,
    height,
  };
  useEffect(() => {
    if (typeof url === "string") {
      setIsPreview(true);
    }
  }, [url]);
  return (
    <div className={`btnChooseImage ${className}`} style={styleBtn}>
      <input
        type="file"
        ref={inputRef}
        accept=".png,.jpg,.jpeg"
        style={{ display: "none" }}
        onChange={handlePreviewIMG}
      />
      {previewIMG && !isPreview ? (
        <div className="haveIMG" style={style}>
          <span className="iconChange" onClick={handleChooseImage}>
            <IconEdit />
          </span>
          <img src={previewIMG.preview} width={200} alt="img"></img>
        </div>
      ) : !previewIMG && !isPreview ? (
        <div className="noIMG">
          <div className="upload" style={style} onClick={handleChooseImage}>
            <IconAddIMG />
          </div>
        </div>
      ) : (
        <div className="haveIMG" style={style}>
          <span className="iconChange" onClick={handleChooseImage}>
            <IconEdit />
          </span>
          <img src={`${window.SERVER_URL}/${url}`} width={200} alt="img"></img>
        </div>
      )}
    </div>
  );
};
export default UploadImage;
